<mat-expansion-panel class="box-shadow border-radius-0" (afterExpand)="onExpand()">
  <mat-expansion-panel-header>
    <mat-panel-title class="panel-header-title">
      <mat-icon [inline]="true" class="opacity-4">air</mat-icon>
      <span>Weather</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-template matExpansionPanelContent>
    <div class="text-center thin-gray-border zulu-time">
      <span class="label-3">Current Time </span>
      <span class="font-bold text-sm">{{ (currentZulu$ |
        async)?.toFormat('HH:mm:ss') }}</span>
      <span class="opacity-6 text-sm"> (Z) {{ (currentZulu$ | async)?.toFormat('LLL dd') }}</span>
    </div>
    <div *ngIf="weather$ | async as weather">
      <div *ngIf="weather.isLoading && !weather.response" class="flex-center mt-32">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
      </div>
      <div *ngIf="!weather.isLoading && !weather.response" class="flex-center" @fadeIn>
        <div class="text-center text-sm">Weather unavailable</div>
      </div>
      <div *ngIf="weather.response">
        <app-station-wx *ngFor="let airportWeather of weather.response?.weatherList" [airportWeather]="airportWeather"
          [departureTime]="flightState?.depTimeActualUTC || flightState?.depTimeReschedUTC || flightState?.depTimeSchedUTC"
          [arrivalTime]="flightState?.arrTimeActualUTC || flightState?.arrTimeReschedUTC || flightState?.arrTimeSchedUTC"></app-station-wx>
      </div>
      <div class="data-status">
        <app-data-status [isLoading]="weather.isLoading" [timestamp]="weather.response?.timestamp"
          (refresh)="refresh()"></app-data-status>
      </div>
      <mat-progress-bar *ngIf="weather.isLoading" class="progress-bar-bottom" color="accent"
        mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-template>
</mat-expansion-panel>